/* ==========================================================================
   THROTTLE CO — tc-apple-polish.js
   Companion to tc-apple-polish.css. No dependencies, loaded deferred.

   1. Lets :active press states fire on iOS.
   2. Keeps --tc-header-h in sync with the real header height (sticky offsets
      and anchor jumps read it).
   3. Under 990px: tucks the sticky header away on scroll down and brings it
      back on scroll up. Never while focus is inside the header, a drawer or
      modal is open, the page is near the top, or reduced motion is on.
   ========================================================================== */

(function () {
  'use strict';

  // iOS Safari only applies :active when a touch listener exists.
  document.addEventListener('touchstart', function () {}, { passive: true });

  var header = document.querySelector('.tc-header-wrapper');
  if (!header) return;

  var root = document.documentElement;

  function syncHeight() {
    var h = header.offsetHeight;
    if (h > 0) root.style.setProperty('--tc-header-h', h + 'px');
  }

  syncHeight();
  if ('ResizeObserver' in window) {
    new ResizeObserver(syncHeight).observe(header);
  } else {
    window.addEventListener('resize', syncHeight);
  }

  // Tuck on scroll only applies to a sticky header.
  if (!header.hasAttribute('data-sticky') || !window.matchMedia) return;

  var HYSTERESIS = 8; // px of travel before the header reacts
  var small = window.matchMedia('(max-width: 989px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastY = Math.max(0, window.scrollY);
  var tucked = false;
  var ticking = false;

  function setTucked(next) {
    if (next === tucked) return;
    tucked = next;
    header.classList.toggle('is-tucked', next);
  }

  function update() {
    ticking = false;

    var max = Math.max(0, root.scrollHeight - window.innerHeight);
    var y = Math.min(Math.max(0, window.scrollY), max); // ignore rubber-banding

    if (!small.matches || reduced.matches) {
      setTucked(false);
      lastY = y;
      return;
    }

    var nearTop = y < header.offsetHeight * 1.5;
    var busy = header.contains(document.activeElement) || document.body.classList.contains('tc-no-scroll');
    if (nearTop || busy) {
      setTucked(false);
      lastY = y;
      return;
    }

    var delta = y - lastY;
    if (Math.abs(delta) < HYSTERESIS) return;
    setTucked(delta > 0);
    lastY = y;
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  header.addEventListener('focusin', function () {
    setTucked(false);
  });
})();
